import { useState } from 'react';

import { cn } from '@utils/cn';

import { Icon } from '@ui-component-library/components/Icon';
import type { IconName } from '@ui-component-library/components/Icon/Icon.types';

import { iconContainerClasses, wrapperClasses } from './Alert.styles';
import type { AlertProps } from './Alert.types';

export const Alert = ({
  icon = 'InfoFilled',
  children,
  allowClose,
  onClose,
  visible = true,
  className
}: AlertProps) => {
  const [isVisible, setIsVisible] = useState(visible);

  const handleClose = () => {
    setIsVisible(false);
    if (onClose) {
      onClose();
    }
  };

  if (!isVisible) {
    return;
  }
  return (
    <div className={cn(wrapperClasses(), className)}>
      <div className={cn(iconContainerClasses())}>
        <Icon name={icon as IconName} size="medium" />
      </div>

      {children}
      {allowClose && (
        <div className={cn(iconContainerClasses({ position: 'trailing' }))} onClick={handleClose}>
          <Icon name="CrossSimple" size="medium" />
        </div>
      )}
    </div>
  );
};
